import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';

import { openAiAssistant } from '../../../../sagas/aiAssistant/actions';
import { setSuggestionsToDisplay } from '../../../../sagas/aiPromptSuggestions/actions';
import { openPricingModal } from '../../../../sagas/pricingModal/actions';
import { ReactComponent as SparklesIcon } from '../../../../assetsNew/icons/ai/sparkles.svg';
import { isAiAssistantVisiblePath, isAiAssistantRaisedLauncherPath, isAiAssistantBarPath, isAiAssistantPanelPath, AI_ASSISTANT_PANEL_MEDIA_QUERY } from '../../../../utils/menu';
import { generateQueryFromString } from '../../../../utils/queryString';

import './_aiAssistantLauncher.scss';

const AIAssistantLauncher = () => {
  const dispatch = useDispatch();
  const { pathname, search } = useLocation();
  const isCreatorPanelScreen = useMediaQuery(AI_ASSISTANT_PANEL_MEDIA_QUERY);
  const { open } = useSelector(state => state.aiAssistant || { open: false });
  const { navbar, menu } = useSelector(state => state.layout);
  const { data: subscriptionData } = useSelector(state => state.getBillingSubscriptionInfo);
  const isVisiblePath = isAiAssistantVisiblePath(pathname);

  if (!navbar && !menu) {
    return null;
  }

  // The Ai Bar replaces the launcher on these routes.
  if (!isVisiblePath || isAiAssistantBarPath(pathname)) {
    return null;
  }

  // The creator panel next to an open channel has its own launcher.
  if (isCreatorPanelScreen && isAiAssistantPanelPath(pathname) && generateQueryFromString(search)?.channel) {
    return null;
  }

  const hasAccess = Boolean(subscriptionData.can_access_ai_chat);

  const handleOpen = () => {
    if (!hasAccess) {
      dispatch(openPricingModal());
      return;
    }
    dispatch(setSuggestionsToDisplay(null));
    dispatch(openAiAssistant());
  };

  if (open) {
    return null;
  }

  return (
    <button className="aiAssistantLauncher" onClick={handleOpen} type="button" aria-label="Open AI assistant" style={isAiAssistantRaisedLauncherPath(pathname) ? { bottom: '123px' } : undefined}>
      <SparklesIcon />
    </button>
  );
};

export default AIAssistantLauncher;
